<template>
  <div class="page-container">
    <MainTitle 
      title="Vocabulary" 
      message="Review your vocabulary here" 
    />
    <div class="app-content-container">
      <FlashcardDeck :cards="vocabularyList" />
    </div>
  </div>
</template>

<script>
import FlashcardDeck from '@/components/flashcards/FlashcardDeck.vue';
import MainTitle from '@/components/title/MainTitle.vue';
import { getWithAuthentication } from '@/services/api';
import { REVIEW_VOCABULARY_ENDPOINT, BASE_URL } from '@/assets/constants/api_endpoints.js';

export default {
  name: 'VocabularyReview',
  components: {
    MainTitle,
    FlashcardDeck,
  },
  data() {
    return {
       vocabularyList: [],
    };
  },

  async mounted() {
    await this.getVocabularyToReview();
  },
  methods: {
      async getVocabularyToReview() {
        try {
          const response = await getWithAuthentication(
                                        BASE_URL, 
                                        REVIEW_VOCABULARY_ENDPOINT
                                  );
          if (response && response.status === 200) {
            const subjectId = this.$route.params.subjectId;
            this.vocabularyList = response.data.filter(
              item => item.is_deleted == false && (!subjectId || item.subject == subjectId)
            );
          } else {
            console.error('Failed to fetch vocabulary for review');
          }
          return;
        } catch (error) {
          this.$router.push({ name: "LoginForm", params: { loggedOut: true } });
        }
      },
  }
};
</script>